
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    setOperationError
} from '../common/client/sagas/common';

import getPromiseCallback from '../common/client/utils/getPromiseCallback';

import {
    SET_OBJECT_INFO
} from './info';

export const SEARCH_OPERATION_ACTION_TYPE = createActionTypes('search/OPERATION');
export const SEARCH_OPEN_ACTION_TYPE = 'search/OPEN';
export const SEARCH_GET_PARAMS_ACTION_TYPE = 'search/GET_PARAMS';
export const SEARCH_RUN_SEARCH_ACTION_TYPE = 'search/RUN_SEARCH';

export default function getActions(dispatch) {
    return {
        getParams: (token, projectId, searchType) => dispatch({
            type: SEARCH_GET_PARAMS_ACTION_TYPE, operation: 'GET_PARAMS',
            token, projectId, searchType
        }),
        openSearch: (searchType) => dispatch({
            type: SEARCH_OPEN_ACTION_TYPE, searchType
        }),
        runSearch: (token, projectId, searchType, params) => dispatch({
            type: SEARCH_RUN_SEARCH_ACTION_TYPE, operation: 'RUN_SEARCH',
            token, projectId, searchType, params
        })
    };
}

function search(serverApi, action) {
    const {type, ...params} = action;
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'search',
            token: action.token,
            body: {
                params: params
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function* workSearchGetParams(options, action) {
    try {
        yield call(clearActionType);
        yield put({type: SEARCH_OPERATION_ACTION_TYPE.DEFAULT});
        yield put({type: SEARCH_OPERATION_ACTION_TYPE.LOADING});
        const data = yield call(search, options.serverApi, action);
        yield put({type: SEARCH_OPERATION_ACTION_TYPE.SUCCESS, data});
    } catch (error) {
        yield call(setOperationError, error, SEARCH_OPERATION_ACTION_TYPE);
    }
}

export function* watchSearchGetParams(options) {
    yield takeEvery(SEARCH_GET_PARAMS_ACTION_TYPE, workSearchGetParams, options);
}

function* workSearchRunSearch(options, action) {
    try {
        yield call(clearActionType);
        yield put({type: SEARCH_OPERATION_ACTION_TYPE.DEFAULT});
        yield put({type: SEARCH_OPERATION_ACTION_TYPE.LOADING});
        const data = yield call(search, options.serverApi, action);
        yield put({type: SEARCH_OPERATION_ACTION_TYPE.SUCCESS, data});
    } catch (error) {
        yield call(setOperationError, error, SEARCH_OPERATION_ACTION_TYPE);
    }
}

export function* watchSearchRunSearch(options) {
    yield takeEvery(SEARCH_RUN_SEARCH_ACTION_TYPE, workSearchRunSearch, options);
}

function* workSearchOpen(options, action) {
    yield put({type: SET_OBJECT_INFO, data: {type: `SEARCH_${action.searchType}`}});
}

export function* watchSearchOpen(options) {
    yield takeEvery(SEARCH_OPEN_ACTION_TYPE, workSearchOpen, options);
}
